"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZoneType = exports.CalendarFormat = exports.TimeFormat = exports.CustomType = exports.CustomFieldType = exports.VideoConferenceType = exports.InPersonType = exports.PhoneCallType = exports.TimeUnit = exports.LicensePlan = exports.LicenseType = void 0;
var LicenseType;
(function (LicenseType) {
    LicenseType["TRIAL"] = "TRIAL";
    LicenseType["ANNUAL"] = "ANNUAL";
    LicenseType["MONTHLY"] = "MONTHLY";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
var LicensePlan;
(function (LicensePlan) {
    LicensePlan["BASIC"] = "BASIC";
    LicensePlan["SCHEDULE"] = "SCHEDULE";
    LicensePlan["JOURNEY"] = "JOURNEY";
    LicensePlan["ENGAGE_AI"] = "ENGAGE_AI";
    LicensePlan["MEET"] = "MEET";
    LicensePlan["CHAT"] = "CHAT";
    LicensePlan["COPILOT"] = "COPILOT";
})(LicensePlan = exports.LicensePlan || (exports.LicensePlan = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["MINUTE"] = "MINUTE";
    TimeUnit["HOUR"] = "HOUR";
    TimeUnit["DAY"] = "DAY";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var PhoneCallType;
(function (PhoneCallType) {
    PhoneCallType["HOST_PHONE_NUMBER"] = "HOST_PHONE_NUMBER";
    PhoneCallType["PROMPT_INVITE"] = "PROMPT_INVITE";
    PhoneCallType["CUSTOM_PHONE"] = "CUSTOM_PHONE";
})(PhoneCallType = exports.PhoneCallType || (exports.PhoneCallType = {}));
var InPersonType;
(function (InPersonType) {
    InPersonType["CUSTOM_ADDRESS"] = "CUSTOM_ADDRESS";
    InPersonType["LOCATION"] = "LOCATION";
    InPersonType["INVITEE_LOCATION"] = "INVITEE_LOCATION";
})(InPersonType = exports.InPersonType || (exports.InPersonType = {}));
var VideoConferenceType;
(function (VideoConferenceType) {
    VideoConferenceType["ZOOM"] = "ZOOM";
    VideoConferenceType["GOOGLE_MEET"] = "GOOGLE_MEET";
    VideoConferenceType["MICROSOFT_TEAMS"] = "MICROSOFT_TEAMS";
    VideoConferenceType["EXTERNAL_GOOGLE_MEET"] = "EXTERNAL_GOOGLE_MEET";
    VideoConferenceType["EXTERNAL_MICROSOFT_TEAMS"] = "EXTERNAL_MICROSOFT_TEAMS";
})(VideoConferenceType = exports.VideoConferenceType || (exports.VideoConferenceType = {}));
var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["NAME"] = "NAME";
    CustomFieldType["EMAIL"] = "EMAIL";
    CustomFieldType["PHONE"] = "PHONE";
    CustomFieldType["CUSTOM"] = "CUSTOM";
    CustomFieldType["LOCATION"] = "LOCATION";
})(CustomFieldType = exports.CustomFieldType || (exports.CustomFieldType = {}));
var CustomType;
(function (CustomType) {
    CustomType["CHECKBOXES"] = "CHECKBOXES";
    CustomType["RADIO_BUTTONS"] = "RADIO_BUTTONS";
    CustomType["SELECT"] = "SELECT";
    CustomType["PHONE"] = "PHONE";
    CustomType["TEXT"] = "TEXT";
    CustomType["TEXTAREA"] = "TEXTAREA";
})(CustomType = exports.CustomType || (exports.CustomType = {}));
var TimeFormat;
(function (TimeFormat) {
    TimeFormat["HOUR_12"] = "HOUR_12";
    TimeFormat["HOUR_24"] = "HOUR_24";
})(TimeFormat = exports.TimeFormat || (exports.TimeFormat = {}));
var CalendarFormat;
(function (CalendarFormat) {
    CalendarFormat["MONTH_VIEW"] = "MONTH_VIEW";
    CalendarFormat["WEEK_VIEW"] = "WEEK_VIEW";
})(CalendarFormat = exports.CalendarFormat || (exports.CalendarFormat = {}));
var TimeZoneType;
(function (TimeZoneType) {
    TimeZoneType["DETECT_INVITEE"] = "DETECT_INVITEE";
    TimeZoneType["DISPLAY_SELECTED"] = "DISPLAY_SELECTED";
})(TimeZoneType = exports.TimeZoneType || (exports.TimeZoneType = {}));
